// @ts-check
/**
 * @type {import('@/utils/i18n/types').I18nRoutes}
 **/
const routes = {
  '/contact': {
    en: '/contact',
    pl: '/kontakt',
    de: '/kontakt'
  },
  '/kontakt': {
    en: '/contact',
    pl: '/kontakt',
    de: '/kontakt'
  },
  '/parkings/[city]/[slug]': {
    en: '/parkings/[city]/[slug]',
    pl: '/parkingi/[city]/[slug]',
    de: '/parkplatze/[city]/[slug]',
    ar: '/parkings/[city]/[slug]'
  },
  '/parkingi/[city]/[slug]': {
    en: '/parkings/[city]/[slug]',
    pl: '/parkingi/[city]/[slug]',
    de: '/parkplatze/[city]/[slug]',
    ar: '/parkings/[city]/[slug]'
  },
  '/parkplatze/[city]/[slug]': {
    en: '/parkings/[city]/[slug]',
    pl: '/parkingi/[city]/[slug]',
    de: '/parkplatze/[city]/[slug]',
    ar: '/parkings/[city]/[slug]'
  },
  '/park-and-fly': {
    en: '/park-and-fly',
    pl: '/park-and-fly',
    de: '/parken-und-fliegen'
  },
  '/warsaw': {
    en: '/warsaw',
    pl: '/warszawa',
    de: '/warschau'
  },
  '/warszawa': {
    en: '/warsaw',
    pl: '/warszawa',
    de: '/warschau'
  },
  '/warschau': {
    en: '/warsaw',
    pl: '/warszawa',
    de: '/warschau'
  },
  '/parkings/[city]': {
    en: '/parkings/[city]',
    pl: '/parkingi/[city]',
    de: '/parkplatze/[city]',
    ar: '/parkings/[city]'
  },
  '/parkingi/[city]': {
    en: '/parkings/[city]',
    pl: '/parkingi/[city]',
    de: '/parkplatze/[city]',
    ar: '/parkings/[city]'
  },
  '/parkplatze/[city]': {
    en: '/parkings/[city]',
    pl: '/parkingi/[city]',
    de: '/parkplatze/[city]',
    ar: '/parkings/[city]'
  },
  '/faq': {
    en: '/faq',
    pl: '/baza-wiedzy',
    de: '/wissensdatenbank',
    ar: '/faq'
  },
  '/baza-wiedzy': {
    en: '/faq',
    de: '/wissensdatenbank',
    ar: '/faq'
  },
  '/wissensdatenbank': {
    en: '/faq',
    pl: '/baza-wiedzy',
    ar: '/faq'
  },
  '/faq/search': {
    en: '/faq/search',
    pl: '/baza-wiedzy/szukaj',
    de: '/wissensdatenbank/suche'
  },
  '/baza-wiedzy/szukaj': {
    en: '/faq/search',
    pl: '/baza-wiedzy/szukaj',
    de: '/wissensdatenbank/suche'
  },
  '/wissensdatenbank/suche': {
    en: '/faq/search',
    pl: '/baza-wiedzy/szukaj',
    de: '/wissensdatenbank/suche'
  },
  '/faq/[category]': {
    en: '/faq/[category]',
    pl: '/baza-wiedzy/[category]',
    de: '/wissensdatenbank/[category]',
    ar: '/faq/[category]'
  },
  '/baza-wiedzy/[category]': {
    en: '/faq/[category]',
    de: '/wissensdatenbank/[category]',
    ar: '/faq/[category]'
  },
  '/wissensdatenbank/[category]': {
    en: '/faq/[category]',
    pl: '/baza-wiedzy/[category]',
    de: '/wissensdatenbank/[category]',
    ar: '/faq/[category]'
  },
  '/parkings': {
    en: '/parkings',
    pl: '/parkingi',
    de: '/parkplatze',
    ar: '/parkings'
  },
  '/parkingi': {
    en: '/parking',
    pl: '/parkingi',
    de: '/parken',
    ar: '/parkings'
  },
  '/parking': {
    en: '/parking',
    pl: '/parkingi',
    de: '/parken',
    ar: '/parkings'
  },
  '/parken': {
    en: '/parking',
    pl: '/parkingi',
    de: '/parken',
    ar: '/parkings'
  },
  '/parkplatze': {
    en: '/parkings',
    pl: '/parkingi',
    de: '/parkplatze',
    ar: '/parkings'
  },
  '/poznań': {
    en: '/poznan',
    pl: '/poznań',
    de: '/poznan'
  },
  '/poznan': {
    en: '/poznan',
    pl: '/poznań',
    de: '/poznan'
  },
  '/platnosci': {
    en: '/payments',
    pl: '/platnosci',
    de: '/zahlungen'
  },
  '/zahlungen': {
    en: '/payments',
    pl: '/platnosci',
    de: '/zahlungen'
  },
  '/payments': {
    en: '/payments',
    pl: '/platnosci',
    de: '/zahlungen'
  },
  '/rezerwacje': {
    en: '/reservations',
    pl: '/rezerwacje',
    de: '/buchungen'
  },
  '/buchungen': {
    en: '/reservations',
    pl: '/rezerwacje',
    de: '/buchungen'
  },
  '/reservations': {
    en: '/reservations',
    pl: '/rezerwacje',
    de: '/buchungen'
  },
  '/abonamenty': {
    en: '/subscriptions',
    pl: '/abonamenty',
    de: '/abonnements'
  },
  '/subscriptions': {
    en: '/subscriptions',
    pl: '/abonamenty',
    de: '/abonnements'
  },
  '/abonnements': {
    en: '/subscriptions',
    pl: '/abonamenty',
    de: '/abonnements'
  },
  '/aplikacja-navipay': {
    en: '/navipay-app',
    de: '/navipay-app',
    ar: 'navipay'
  },
  '/navipay-app': {
    en: '/navipay-app',
    de: '/navipay-app',
    pl: '/aplikacja-navipay',
    ar: 'navipay'
  },
  '/parkhauser-parkplatze': {
    en: '/parking',
    pl: '/parkowanie',
    de: '/parkhauser-parkplatze'
  },
  '/parkowanie': {
    en: '/parking',
    pl: '/parkowanie',
    de: '/parkhauser-parkplatze'
  },
  '/katowice': {
    en: '/katowice',
    pl: '/katowice',
    de: '/kattowitz'
  },
  '/kattowitz': {
    en: '/katowice',
    pl: '/katowice',
    de: '/kattowitz'
  },
  '/olsztyn': {
    en: '/olsztyn',
    pl: '/olsztyn',
    de: '/allenstein'
  },
  '/allenstein': {
    en: '/olsztyn',
    pl: '/olsztyn',
    de: '/allenstein'
  },
  '/krakow': {
    en: '/cracow',
    pl: '/krakow',
    de: '/krakau'
  },
  '/cracow': {
    en: '/cracow',
    pl: '/krakow',
    de: '/krakau'
  },
  '/krakau': {
    en: '/cracow',
    pl: '/krakow',
    de: '/krakau'
  },
  '/kattowitz-pyrzowice': {
    en: '/katowice-pyrzowice',
    pl: '/katowice-pyrzowice',
    de: '/kattowitz-pyrzowice'
  },
  '/katowice-pyrzowice': {
    en: '/katowice-pyrzowice',
    pl: '/katowice-pyrzowice',
    de: '/kattowitz-pyrzowice'
  },
  '/swinemunde': {
    en: '/swinoujscie',
    pl: '/swinoujscie',
    de: '/swinemunde'
  },
  '/swinoujscie': {
    en: '/swinoujscie',
    pl: '/swinoujscie',
    de: '/swinemunde'
  },
  '/danzig': {
    en: '/gdansk',
    pl: '/gdansk',
    de: '/danzig'
  },
  '/gdansk': {
    en: '/gdansk',
    pl: '/gdansk',
    de: '/danzig'
  },
  '/breslau': {
    en: '/wroclaw',
    pl: '/wroclaw',
    de: '/breslau'
  },
  '/wroclaw': {
    en: '/wroclaw',
    pl: '/wroclaw',
    de: '/breslau'
  },
  '/dubai': {
    en: '/dubai',
    pl: '/dubai',
    de: '/dubai',
    ar: '/dubai'
  },
  '/car-parks': {
    en: '/car-parks',
    pl: '/parkingi',
    de: '/parkhauser-parkplatze',
    ar: '/car-parks'
  },
  '/parking-general-information': {
    en: '/parking-general-information',
    pl: '/parkowanie-informacje-ogolne',
    de: '/parken-allgemeine-informationen',
    ar: '/parking-general-information'
  },
  '/parkowanie-informacje-ogolne': {
    en: '/parking-general-information',
    de: '/parken-allgemeine-informationen',
    ar: '/parking-general-information'
  },
  '/parken-allgemeine-informationen': {
    en: '/parking-general-information',
    pl: '/parkowanie-informacje-ogolne',
    ar: '/parking-general-information'
  },
  '/reservations-and-subscriptions': {
    en: '/reservations-and-subscriptions',
    pl: '/rezerwacje-i-abonamenty',
    de: '/reservierungen-und-abonnements',
    ar: '/reservations-and-subscriptions'
  },
  '/rezerwacje-i-abonamenty': {
    en: '/reservations-and-subscriptions',
    de: '/reservierungen-und-abonnements',
    ar: '/reservations-and-subscriptions'
  },
  '/reservierungen-und-abonnements': {
    en: '/reservations-and-subscriptions',
    pl: '/rezerwacje-i-abonamenty',
    ar: '/reservations-and-subscriptions'
  },
  '/cyfrowyparking': {
    en: '/cyfrowyparking',
    pl: '/cyfrowyparking',
    de: '/cyfrowyparking',
    ar: '/cyfrowyparking'
  },
  '/security-and-payment': {
    en: '/security-and-payment',
    pl: '/bezpieczenstwo-i-platnosc',
    de: '/sicherheit-und-zahlung',
    ar: '/security-and-payment'
  },
  '/bezpieczenstwo-i-platnosc': {
    en: '/security-and-payment',
    de: '/sicherheit-und-zahlung',
    ar: '/security-and-payment'
  },
  '/sicherheit-und-zahlung': {
    en: '/security-and-payment',
    pl: '/bezpieczenstwo-i-platnosc',
    ar: '/security-and-payment'
  },
  '/parking-search': {
    pl: '/wyszukiwanie-parkingow',
    ar: '/parking-search',
    de: '/parkplatzsuche',
    en: '/parking-search'
  },
  '/wyszukiwanie-parkingow': {
    en: '/parking-search',
    ar: '/parking-search',
    de: '/parkplatzsuche',
    pl: '/wyszukiwanie-parkingow'
  },
  '/parkplatzsuche': {
    en: '/parking-search',
    pl: '/wyszukiwanie-parkingow',
    ar: '/parking-search',
    de: '/parkplatzsuche'
  },
  '/parking-search/[town]': {
    pl: '/wyszukiwanie-parkingow/[town]',
    ar: '/parking-search/[town]',
    de: '/parkplatzsuche/[town]',
    en: '/parking-search/[town]'
  },
  '/wyszukiwanie-parkingow/[town]': {
    en: '/parking-search/[town]',
    ar: '/parking-search/[town]',
    de: '/parkplatzsuche/[town]',
    pl: '/wyszukiwanie-parkingow/[town]'
  },
  '/parkplatzsuche/[town]': {
    en: '/parking-search/[town]',
    pl: '/wyszukiwanie-parkingow/[town]',
    ar: '/parking-search/[town]',
    de: '/parkplatzsuche/[town]'
  }
}

module.exports = routes
